import { render } from "./custom-hot-area.vue?vue&type=template&id=1bd4e5a2"
import script from "./custom-hot-area.vue?vue&type=script&lang=js"
export * from "./custom-hot-area.vue?vue&type=script&lang=js"

import "./custom-hot-area.vue?vue&type=style&index=0&id=1bd4e5a2&lang=scss"
script.render = render

export default script